import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Typography,
  Button,
  InputNumber,
  Popconfirm,
  Space,
  Select,
  Modal,
  Divider,
  Alert,
  AutoComplete,
  Tooltip,
  DatePicker,
  Dropdown,
  notification,
} from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, PlusOutlined, RedoOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";
import Title from "antd/es/skeleton/Title";
import { QuotationService } from "../../../../Services/Manage/QuotationService";
import { LetterService } from "../../../../Services/Manage/LetterService";
import { ENDPOINT } from "../../../../Services/ENDPOINT";
import dayjs from "dayjs";
import { BankService } from "../../../../Services/Manage/BankService";
import { UserService } from "../../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import CreatePayment from "../../../modals/CreatePayment";
import html2pdf from "html2pdf.js";
import { EnquiryService } from "../../../../Services/Manage/EnquiryService";
import QuotationInvoiceTemplate from "../../template/QuotationInvoiceTemplate";
import useNotification from "antd/es/notification/useNotification";
import QuoteUpdate from "../../template/QuoteUpdate";

const EditQuotationData = ({
  followDate,
  quteData,
  Eqslected,
  data,
  initialData,
  selectedDate,
  eqData,
  customerForm
}) => {
  const { Text, Title } = Typography;
  const [form] = Form.useForm();
  const [selectBank] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [count, setCount] = useState(3);
  const [grandTotal, setGrandTotal] = useState(0);
  const [message, msgContc] = useMessage();
  const [letterHead, setLetterHead] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedTC, setSelectedTC] = useState([]);
  const [selectedTCOption, setSelectedTCOption] = useState([]);
  const [dgSign, setDGsign] = useState(null);
  const [dgSignOption, setDGsignOption] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [bankAc, setBankAc] = useState(null);
  const [bankAcOption, setBankAcOption] = useState([]);

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [quotationNo, setQuotationNo] = useState(null);

  const [quoteTwo, setQuoteTwo] = useState(false);
  const [taxRate, setTaxRate] = useState(0);

  const [options, setOptions] = useState([]);
  const [autoSuggestion, setSuggestion] = useState({
    products: {},
    services: [],
  });
  const [customerData, setCustomerData] = useState([]);
  const [quoteTitle, setQuoteTitle] = useState('');

  const [notification, notiContec] = useNotification();

  const getBase64Image = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // important for CORS
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });

  const waitForImages = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = () => resolve();
        img.onerror = () => resolve(); // still resolve to avoid blocking PDF
      });
    });
    return Promise.all(promises);
  };

  const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
  const handleSearch = (value) => {
    setOptions(
      value
        ? taxOptions
          .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
          .map((tax) => ({ value: tax }))
        : []
    );
  };
  const handlePreview = () => {
    if (selectedValue) {
      setIsModalOpen(true);
    }
  };

  console.log(data, selectedDate);

  const getAllLetterhead = async () => {
    try {
      const request = await LetterService.getAllHead();
      setLetterHead(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getBankAcOption = async () => {
    try {
      const request = await BankService.getAllBank();
      setBankAcOption(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllTCData = async () => {
    try {
      const response = await LetterService.getAllTC();
      setSelectedTCOption(
        response.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllProductSuggestions = async () => {
    try {
      const res = await EnquiryService.getAllGenSuggestions();
      setSuggestion(buildSelectOptions(res));

    } catch (error) {
      console.error(error);
    }
  };

  const getDigitalSign = async () => {
    try {
      const response = await QuotationService.getDigitalSign();
      setDGsignOption(
        response.data.map((item) => ({
          label: (
            <img
              src={`${ENDPOINT.base}/${item.image_path}`}
              alt={`Signature ${item.id}`}
              style={{ width: "100px", height: "auto", objectFit: "contain" }}
            />
          ),
          value: item.id,
          title: `Signature ${item.id}`,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getCustomerData = async (qu_id) => {
    try {
      const request = await EnquiryService.getCustomerDataByQuID(qu_id);
      setCustomerData(request.data)
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getAllLetterhead();
    getAllTCData();
    getBankAcOption();
    getAllProductSuggestions();
    getDigitalSign();
    form.setFieldsValue({
      quotationNo: quteData?.qu_no,
      gstNo: quteData?.cus_gst,
      tax_id: quteData?.tax_id,
      tax_type: quteData?.tax_type,
      vaild_date: quteData?.vaild_date
        ? dayjs(quteData.vaild_date)
        : null,
      supply_add: quteData?.supply_add,
    });

    getCustomerData(quteData?.qu_no);

    setTaxRate(Number.isFinite(Number(quteData?.tax)) ? Number(quteData.tax) : 0);

    const formattedData = initialData.map((item, index) => ({
      ...item,
      key: item.id ?? index,
      description_value: item.desc_id
        ? `${item.desc_type}-${item.desc_id}`
        : null,
      // Ensure all numeric fields are properly converted to numbers
      qty: Number(item.qty) || 0,
      unitprice: Number(item.unitprice) || 0,
      totalprice: Number(item.totalprice) || 0,
      tax: Number(item.tax) || 0,
      // Initialize Quote 2 fields
      supply_rate: Number(item.supply_rate) || 0,
      supply_amt: Number(item.supply_amt) || 0,
      install_rate: Number(item.install_rate) || 0,
      install_amt: Number(item.install_amt) || 0,
    }));

    setDataSource(formattedData);

    // Check if any row has Quote 2 data
    const hasQuote2Data = formattedData.some(
      item => item.supply_rate > 0 || item.install_rate > 0
    );
    if (hasQuote2Data) {
      setQuoteTwo(true);
    }

    console.log(initialData);
  }, [data, form, initialData, quteData]);

  const TruncatedLabel = ({ text, maxWidth = "50ch" }) => (
    <span
      style={{
        maxWidth,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block",
        verticalAlign: "middle",
      }}
      title={text} // full text on hover
    >
      {text}
    </span>
  );

  //bank ac
  useEffect(() => {
    if (bankAcOption.length > 0 && quteData?.bank_id) {
      const selected = bankAcOption.find(
        (opt) => opt.value === Number(quteData.bank_id)
      );
      if (selected) {
        selectBank.setFieldsValue({
          bank_ac: selected?.tag,
        });

        setBankAc(selected);
      }
    }
  }, [bankAcOption, quteData]);

  useEffect(() => {
    if (letterHead.length > 0 && quteData?.header_id) {
      const selected = letterHead.find(
        (opt) => opt.value === Number(quteData.header_id)
      );
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [letterHead, quteData]);

  useEffect(() => {
    if (selectedTCOption.length > 0 && quteData?.tc_id) {
      const selected = selectedTCOption.find(
        (opt) => opt.value === Number(quteData.tc_id)
      );
      if (selected) {
        setSelectedValue(selected);
      }
    }
  }, [selectedTCOption, quteData]);

  useEffect(() => {
    if (dgSignOption.length > 0 && quteData?.sign_id) {
      const selected = dgSignOption.find(
        (opt) => opt.value === Number(quteData.sign_id)
      );
      if (selected) {
        setDGsign(selected);
      }
    }
  }, [dgSignOption, quteData]);

  // FIXED: Indian numbering system for number to words
  const numberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if (num === 0) return "Zero";

    // Indian numbering system: Ones, Tens, Hundreds, Thousands, Lakhs, Crores
    const convertToWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convertToWords(n % 100) : "");
      if (n < 100000) {
        // Thousands
        return convertToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convertToWords(n % 1000) : "");
      }
      if (n < 10000000) {
        // Lakhs (1 lakh = 100,000)
        const lakhs = Math.floor(n / 100000);
        const remainder = n % 100000;
        return convertToWords(lakhs) + " Lakh" + (remainder ? " " + convertToWords(remainder) : "");
      }
      // Crores (1 crore = 10,000,000)
      const crores = Math.floor(n / 10000000);
      const remainder = n % 10000000;
      return convertToWords(crores) + " Crore" + (remainder ? " " + convertToWords(remainder) : "");
    };

    return convertToWords(Math.floor(num)).trim();
  };

  useEffect(() => {
    calculateGrandTotal();
  }, [dataSource, taxRate, quoteTwo]);

  const handleDelete = async (record) => {
    console.log(record);
    try {
      const request = await QuotationService.deleteQuotation(record.id);
      const newData = dataSource.filter((item) => item.id !== record.id);
      setDataSource(newData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDescriptionSelect = (rowKey, value, option) => {
    console.log("Row Key:", rowKey);
    console.log("Selected Value:", value);
    console.log("Selected Option:", option);

    if (!option) {
      setDataSource(prev =>
        prev.map(item =>
          item.key === rowKey
            ? {
              ...item,
              description: "",
              desc_id: null,
              type: null,
              unit: "",
              sku: "",
              unitprice: 0,
              totalprice: 0,
              supply_rate: 0,
              supply_amt: 0,
              install_rate: 0,
              install_amt: 0,
            }
            : item
        )
      );
      return;
    }

    // Extract custom attributes
    const id = option.props["data-id"];
    const type = option.props["data-type"];
    const name = option.props["data-name"];

    console.log("Selected ID:", id);
    console.log("Selected Type:", type);

    // OPTIONAL: auto-fill row values
    setDataSource(prev =>
      prev.map(item => {
        if (item.key !== rowKey) return item;

        let unitprice = 0;
        let unit = "";
        let sku = "";
        let desc_id = "";
        let tax = 0;

        if (type === "product") {
          const product = autoSuggestion.products
            ? Object.values(autoSuggestion.products)
              .flat()
              .find(p => p.id === id)
            : null;

          if (product) {
            unitprice = Number(product.unit_price || 0);
            unit = product.unit || "";
            sku = product.sku || "";
            desc_id = product.id || "";
            tax = Number(product.gst || item.tax || 0);
          }
        }

        // Changed from "service" to "generator" for EditQuotationData
        if (type === "generator") {
          const generator = autoSuggestion.services.find(s => s.id === id);
          if (generator) {
            unitprice = Number(generator.price || 0);
            unit = generator.unit || "";
            sku = generator.sku || "";
            desc_id = generator.id;
            tax = Number(generator.gst || item.tax || 0);
          }
        }

        const qty = item.qty || 1;
        const base = qty * unitprice;

        return {
          ...item,
          description: name || "",
          unit,
          type,
          sku,
          desc_id,
          tax: Number(tax),
          unitprice: Number(unitprice),
          totalprice: Math.round(base + (base * tax) / 100),
          supply_rate: Number(item.supply_rate) || 0,
          supply_amt: Number(item.supply_amt) || 0,
          install_rate: Number(item.install_rate) || 0,
          install_amt: Number(item.install_amt) || 0,
        };
      })
    );
  };

  const buildSelectOptions = (apiData) => {
    const options = [];

    console.log(":apiData:", apiData);

    /* ================= PRODUCTS ================= */
    if (apiData.products) {
      const productGroups = Object.entries(apiData.products).map(
        ([subGroupName, items]) => ({
          label: subGroupName,
          options: items.map((item) => ({
            label: `${item.name} (${item.sku})`,
            value: `product-${item.id}`,
            searchLabel: `${item.name} ${item.sku} ${subGroupName}`,
            meta: {
              id: item.id,
              type: "product",
            },
          })),
        })
      );

      options.push({
        label: "PRODUCTS",
        options: productGroups,
      });
    }

    /* ================= GENERATOR (instead of services) ================= */
    if (apiData.generator) {
      options.push({
        label: "GENERATOR",
        options: apiData.generator.map((item) => ({
          label: `${item.name} (${item.sku})`,
          value: `generator-${item.id}`,
          searchLabel: `${item.name} ${item.sku}`,
          meta: {
            id: item.id,
            type: "generator",
          },
        })),
      });
    }

    return {
      products: apiData.products || {},
      services: apiData.generator || [],
    };
  };

  const handleChange = (key, field, value) => {
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        // Ensure the value is properly converted to a number
        const numericValue = Number(value) || 0;
        const updatedItem = { ...item, [field]: numericValue };

        if (quoteTwo) {
          // Quote 2 calculations - ensure all values are numbers
          const qty = Number(updatedItem.qty) || 0;
          const supplyRate = Number(updatedItem.supply_rate) || 0;
          const installRate = Number(updatedItem.install_rate) || 0;
          
          updatedItem.supply_amt = Math.round(qty * supplyRate);
          updatedItem.install_amt = Math.round(qty * installRate);
        } else {
          // Regular calculation - ensure all values are numbers
          const qty = Number(updatedItem.qty) || 0;
          const unitprice = Number(updatedItem.unitprice) || 0;
          const basePrice = qty * unitprice;
          const taxPercent = Number(updatedItem.tax) || 0;
          const total = basePrice + (basePrice * taxPercent) / 100;
          updatedItem.totalprice = Math.round(total);
        }

        return updatedItem;
      }
      return item;
    });
    setDataSource(newData);
  };

  const calculateGrandTotal = () => {
    if (quoteTwo) {
      // Quote 2 calculation - ensure all values are numbers
      const supplyTotal = dataSource.reduce((sum, item) => {
        const amt = Number(item.supply_amt) || 0;
        return sum + amt;
      }, 0);
      
      const installTotal = dataSource.reduce((sum, item) => {
        const amt = Number(item.install_amt) || 0;
        return sum + amt;
      }, 0);

      const numericTaxRate = Number(taxRate) || 0;
      const supplyTax = Math.round((supplyTotal * numericTaxRate) / 100);
      const installTax = Math.round((installTotal * numericTaxRate) / 100);

      const total = supplyTotal + installTotal + supplyTax + installTax;
      setGrandTotal(total);
    } else {
      // Regular calculation - ensure all values are numbers
      const total = dataSource.reduce((sum, item) => {
        const price = Number(item.totalprice) || 0;
        return sum + price;
      }, 0);
      setGrandTotal(total);
    }
  };

  const InfoIcon = ({ title }) => (
    <Tooltip placement="topRight" title={title}>
      <ExclamationCircleOutlined
        style={{ color: "#999", cursor: "pointer" }}
        onClick={(e) => e.stopPropagation()} // IMPORTANT
      />
    </Tooltip>
  );

  // Regular columns
  const regularColumns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "7%",
      align: "center",
      key: "key",
      render: (_, __, index) => index + 1,
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Description</span>
          <RedoOutlined onClick={() => getAllProductSuggestions()} style={{ cursor: "pointer" }} />
        </div>
      ),
      width: '32%',
      dataIndex: "description",
      key: "description",
      render: (text, record) => (
        <Select
          showSearch
          allowClear
          style={{ width: 500 }}
          placeholder="Select product / generator"
          optionFilterProp="data-search"
          optionLabelProp="label"
          size="large"
          value={record.description}
          suffixIcon={
            <InfoIcon
              title={
                record.description
                  ? record.description
                  : "Select a product or generator"
              }
            />
          }
          onChange={(value, option) =>
            handleDescriptionSelect(record.key, value, option)
          }
        >
          {/* ================= GENERATOR (first) ================= */}
          {autoSuggestion.services?.length > 0 && (
            <>
              <Select.Option
                disabled
                key="generator-header"
                style={{
                  fontWeight: 600,
                  cursor: "default",
                  background: "#fafafa",
                }}
              >
                POWER MACHINES
              </Select.Option>

              {autoSuggestion.services.map((item) => (
                <Select.Option
                  key={`generator-${item.id}`}
                  value={`generator-${item.id}`}
                  data-id={item.id}
                  data-name={item.name}
                  data-type="generator"
                  data-search={`${item.name} ${item.sku}`}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        maxWidth: 400,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                      }}
                    >
                      {item.name} ({item.sku})
                    </span>

                    <Tooltip
                      placement="right"
                      title={
                        <div>
                          <div><strong>Power Machine Name:</strong> {item.name}</div>
                          <div><strong>Code:</strong> {item.sku}</div>
                        </div>
                      }
                    >
                      <ExclamationCircleOutlined
                        style={{ color: "#999", cursor: "pointer" }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Tooltip>
                  </div>
                </Select.Option>
              ))}
            </>
          )}

          {/* ================= PRODUCTS ================= */}
          {autoSuggestion.products &&
            Object.entries(autoSuggestion.products).map(
              ([categoryName, items]) => (
                <React.Fragment key={categoryName}>
                  <Select.Option
                    disabled
                    key={`cat-${categoryName}`}
                    style={{
                      fontWeight: 400,
                      cursor: "default",
                      background: "#fafafa",
                    }}
                  >
                    {categoryName}
                  </Select.Option>

                  {items.map((item) => (
                    <Select.Option
                      key={`product-${item.id}`}
                      value={`product-${item.id}`}
                      data-id={item.id}
                      data-name={item.name}
                      data-type="product"
                      data-search={`${item.name} ${item.sku} ${categoryName}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span
                          style={{
                            maxWidth: 400,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                          }}
                        >
                          {item.name} ({item.sku})
                        </span>

                        <Tooltip
                          placement="right"
                          title={
                            <div>
                              <div><strong>Product Name:</strong> {item.name}</div>
                              <div><strong>HSN/SAC Code:</strong> {item.sku}</div>
                              <div><strong>Category:</strong> {categoryName}</div>
                              <div><strong>Unit:</strong> {item.unit}</div>
                              <div><strong>Unit Price:</strong> {item.unit_price}</div>
                            </div>
                          }
                        >
                          <ExclamationCircleOutlined
                            style={{ color: "#999", cursor: "pointer" }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </Tooltip>
                      </div>
                    </Select.Option>
                  ))}
                </React.Fragment>
              )
            )}
        </Select>
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "5%",
      align: "center",
      key: "qty",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "qty", value)}
        />
      ),
    },
    {
      title: "HSN/SAC Code",
      dataIndex: "sku",
      width: "12%",
      align: "center",
      key: "sku",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleChange(record.key, "sku", e.target.value)}
        />
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: '8%',
      align: 'center',
      key: "unit",
      render: (text, record) => (
        <Input
          readOnly
          value={text}
          onChange={(value) => handleChange(record.key, "unit", value)}
        />
      ),
    },
    {
      title: "Unit Price",
      dataIndex: "unitprice",
      align: "center",
      width: "10%",
      key: "unitprice",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "unitprice", value)}
        />
      ),
    },
    {
      title: "Tax (in %)",
      dataIndex: "tax",
      width: "12%",
      align: "center",
      key: "tax",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "tax", value)}
        />
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalprice",
      align: "center",
      key: "totalprice",
      render: (text) => <Text>{text || 0}</Text>,
      width: "10%",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            // disabled={!Eqslected}
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button  icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Quote 2 columns
  const quote2Columns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "5%",
      align: "center",
      key: "key",
      render: (_, __, index) => index + 1,
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Description</span>
          <RedoOutlined onClick={() => getAllProductSuggestions()} style={{ cursor: "pointer" }} />
        </div>
      ),
      width: '25%',
      dataIndex: "description",
      key: "description",
      render: (text, record) => (
        <Select
          showSearch
          allowClear
          style={{ width: 400 }}
          placeholder="Select product / generator"
          optionFilterProp="data-search"
          optionLabelProp="label"
          size="large"
          value={record.description}
          suffixIcon={
            <InfoIcon
              title={
                record.description
                  ? record.description
                  : "Select a product or generator"
              }
            />
          }
          onChange={(value, option) =>
            handleDescriptionSelect(record.key, value, option)
          }
        >
          {/* Same options as regular columns */}
          {autoSuggestion.services?.length > 0 && (
            <>
              <Select.Option
                disabled
                key="generator-header"
                style={{
                  fontWeight: 600,
                  cursor: "default",
                  background: "#fafafa",
                }}
              >
                POWER MACHINES
              </Select.Option>

              {autoSuggestion.services.map((item) => (
                <Select.Option
                  key={`generator-${item.id}`}
                  value={`generator-${item.id}`}
                  data-id={item.id}
                  data-name={item.name}
                  data-type="generator"
                  data-search={`${item.name} ${item.sku}`}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        maxWidth: 300,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                      }}
                    >
                      {item.name} ({item.sku})
                    </span>
                    <Tooltip
                      placement="right"
                      title={
                        <div>
                          <div><strong>Power Machine Name:</strong> {item.name}</div>
                          <div><strong>Code:</strong> {item.sku}</div>
                        </div>
                      }
                    >
                      <ExclamationCircleOutlined
                        style={{ color: "#999", cursor: "pointer" }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Tooltip>
                  </div>
                </Select.Option>
              ))}
            </>
          )}

          {autoSuggestion.products &&
            Object.entries(autoSuggestion.products).map(
              ([categoryName, items]) => (
                <React.Fragment key={categoryName}>
                  <Select.Option
                    disabled
                    key={`cat-${categoryName}`}
                    style={{
                      fontWeight: 400,
                      cursor: "default",
                      background: "#fafafa",
                    }}
                  >
                    {categoryName}
                  </Select.Option>
                  {items.map((item) => (
                    <Select.Option
                      key={`product-${item.id}`}
                      value={`product-${item.id}`}
                      data-id={item.id}
                      data-name={item.name}
                      data-type="product"
                      data-search={`${item.name} ${item.sku} ${categoryName}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span
                          style={{
                            maxWidth: 300,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                          }}
                        >
                          {item.name} ({item.sku})
                        </span>
                        <Tooltip
                          placement="right"
                          title={
                            <div>
                              <div><strong>Product Name:</strong> {item.name}</div>
                              <div><strong>HSN/SAC Code:</strong> {item.sku}</div>
                              <div><strong>Category:</strong> {categoryName}</div>
                              <div><strong>Unit:</strong> {item.unit}</div>
                              <div><strong>Unit Price:</strong> {item.unit_price}</div>
                            </div>
                          }
                        >
                          <ExclamationCircleOutlined
                            style={{ color: "#999", cursor: "pointer" }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </Tooltip>
                      </div>
                    </Select.Option>
                  ))}
                </React.Fragment>
              )
            )}
        </Select>
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "5%",
      align: "center",
      key: "qty",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "qty", value)}
        />
      ),
    },
    {
      title: "HSN/SAC Code",
      dataIndex: "sku",
      width: "10%",
      align: "center",
      key: "sku",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleChange(record.key, "sku", e.target.value)}
        />
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: '7%',
      align: 'center',
      key: "unit",
      render: (text, record) => (
        <Input
          readOnly
          value={text}
          onChange={(value) => handleChange(record.key, "unit", value)}
        />
      ),
    },
    {
      title: "SUPPLY & INSTALLATION",
      align: "center",
      children: [
        {
          title: "RATE",
          dataIndex: "supply_rate",
          key: "supply_rate",
          // width: "8%",
          align: "center",
          render: (text, record) => (
            <InputNumber
              min={0}
              value={text}
              onChange={(value) => handleChange(record.key, "supply_rate", value)}
            />
          ),
        },
        {
          title: "AMOUNT",
          dataIndex: "supply_amt",
          key: "supply_amt",
          // width: "8%",
          align: "center",
          render: (text) => <Text>{text || 0}</Text>,
        },
      ],
    },
    // {
    //   title: "INSTALLATION",
    //   align: "center",
    //   children: [
    //     {
    //       title: "RATE",
    //       dataIndex: "install_rate",
    //       key: "install_rate",
    //       width: "8%",
    //       align: "center",
    //       render: (text, record) => (
    //         <InputNumber
    //           min={0}
    //           value={text}
    //           onChange={(value) => handleChange(record.key, "install_rate", value)}
    //         />
    //       ),
    //     },
    //     {
    //       title: "AMOUNT",
    //       dataIndex: "install_amt",
    //       key: "install_amt",
    //       width: "8%",
    //       align: "center",
    //       render: (text) => <Text>{text || 0}</Text>,
    //     },
    //   ],
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            disabled={!Eqslected}
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button disabled={!Eqslected} icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const columns = quoteTwo ? quote2Columns : regularColumns;

  const handleNewAdd = () => {
    setDataSource([
      ...dataSource,
      {
        key: count,
        description: "",
        qty: 1,
        sku: "",
        unitprice: 0,
        totalprice: 0,
        supply_rate: 0,
        supply_amt: 0,
        install_rate: 0,
        install_amt: 0,
      },
    ]);
    setCount(count + 1);
  };

  const handleQuoteTwo = () => {
    setQuoteTwo(!quoteTwo);
    console.log("quoteTwo", !quoteTwo);
  }

  const handleAdd = (key) => {
    const newRow = {
      key: count,
      description: "",
      qty: 1,
      sku: "",
      unitprice: 0,
      totalprice: 0,
      supply_rate: 0,
      supply_amt: 0,
      install_rate: 0,
      install_amt: 0,
    };
    const index = dataSource.findIndex((item) => item.key === key);

    let newData = [...dataSource];
    newData.splice(index + 1, 0, newRow);
    setDataSource(newData);
    setCount(count + 1);
  };

  const menu = {
    items: [
      {
        key: "draft",
        label: "Save as Draft",
        onClick: () => handleSave("Draft"),
      },
    ],
  };

  console.log("quteData", quteData);

  const handleSave = async (status = "Active") => {
    try {
      if (!dataSource || dataSource.length <= 0) {
        return notification.warning("Please Add contents");
      }

      const customerValues = customerForm.getFieldsValue();
      await customerForm.validateFields();

      const request = form.getFieldsValue();
      const user = await UserService.getOmeUser();

      const formattedData = dataSource.map((item) => ({
        id: item.id,
        description: item.description,
        qty: item.qty,
        sku: item.sku,
        qu_no: request.quotationNo,
        unit: item.unit,
        desc_id: item.desc_id,
        type: item.type,

        ...(!quoteTwo && {
          totalprice: item.totalprice,
          unitprice: item.unitprice,
          tax: item.tax,
        }),
        // Add Quote 2 fields
        supply_rate: item.supply_rate || 0,
        supply_amt: item.supply_amt || 0,
        install_rate: item.install_rate || 0,
        install_amt: item.install_amt || 0,
      }));

      console.log('dataSource', dataSource);
      console.log("formattedData", formattedData);

      const data_insert = {
        qu_no: request.quotationNo,
        tax_id: request.tax_id,
        tax_type: request.tax_type,
        eq_no: eqData?.eq_id,
        cus_gst: request?.gstNo,

        tc_id: selectedValue?.id || null,
        sign_id: dgSign?.id || null,
        bank_id: bankAc?.id || null,

        added_by: user?.uid,
        status: status === "Draft" ? "Draft" : "Active",

        ...(taxRate && { tax: taxRate }),

        ...(request && { vaild_date: request.vaild_date }),
        ...(request && { supply_add: request.supply_add }),

        ...(selectedDate && { date: selectedDate }),
        ...(followDate && { n_follow_up: followDate }),
      };

      const payload = {
        ...customerValues,
        n_follow_up: customerValues.n_follow_up
          ? customerValues.n_follow_up.format("DD-MM-YYYY")
          : null,
      };

      const send_both = {
        formattedData,
        quotation_insert: data_insert,
        ...(eqData?.eq_id ? {} : { customer_data: payload }),
      };

      const requests = await QuotationService.updateQuotation(
        send_both,
        request.quotationNo
      );

      if (requests.status) message.success(requests.message);
      else message.error(requests.message);

    } catch (error) {
      console.error(error);
    }
  };

  const handlePrintInvoice = async (qu_no) => {
    try {
      console.log('customerForm', customerForm);

      const quotationRes = await QuotationService.getAllQuotationById(qu_no);
      const quotation = quotationRes?.data?.quotation;
      const quotationData = dataSource;

      const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
      const customer = await EnquiryService.getCustomerDataByQuID(qu_no);

      console.log("customer++", customer);

      const enquiry = enquiryRes?.data || customer?.data;

      const headerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "header");
      const footerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "footer");
      const watermarkImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "watermark");

      const headerBase64 = headerImageObj ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`) : "";
      const footerBase64 = footerImageObj ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`) : "";
      const dgSignBase64 = dgSign ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`) : "";
      const watermarkBase64 = watermarkImageObj ? await getBase64Image(`${ENDPOINT.base}/${watermarkImageObj.image_url}`) : "";

      const pdfDoc = QuotationInvoiceTemplate({
        headerBase64,
        footerBase64,
        dgSignBase64,
        watermarkBase64,
        quotation,
        enquiry,
        quotationData,
        invoice_date: quotation.date,
        grandTotal,
        numberToWords,
        bankAc,
        selectedValue,
        tax_type: form.getFieldValue("tax_type"),
        tax_id: form.getFieldValue("tax_id"),
        type: "QUOTATION"
      });

      pdfDoc.save(`${quotation?.qu_no || "Quotation"}_quotation.pdf`);
      pdfDoc.output("dataurlnewwindow");

    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF!");
    }
  };

  const handlePrintInvoiceTypeTwo = async (qu_no) => {
    try {
      const quotationRes = await QuotationService.getAllQuotationById(qu_no);
      const quotation = quotationRes?.data?.quotation;
      const quotationData_before = dataSource;

      const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
      const customer = await EnquiryService.getCustomerDataByQuID(qu_no);

      const formatQoute = await EnquiryService.getFormatedData(quotationData_before);
      console.log("response.data",formatQoute.data);
      

      // const quotationData = dataSource;
      const quotationData = dataSource.map((item, index) => ({
        ...item,
        si_no: index + 1
      }));

      console.log("dataSource",dataSource);      

      console.log("quotationData After send+++", formatQoute.data);
      console.log("quotationData before send+++", quotationData_before);

      const enquiry = enquiryRes?.data || customer?.data;

      const headerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "header");
      const footerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "footer");
      const watermarkImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "watermark");

      const headerBase64 = headerImageObj ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`) : "";
      const footerBase64 = footerImageObj ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`) : "";
      const dgSignBase64 = dgSign ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`) : "";
      const watermarkBase64 = watermarkImageObj ? await getBase64Image(`${ENDPOINT.base}/${watermarkImageObj.image_url}`) : "";

      const pdfDoc = QuoteUpdate({
        quotationData,
        headerBase64,
        footerBase64,
        dgSignBase64,
        watermarkBase64,
        quotation,
        enquiry,
        invoice_date: quotation.date,
        grandTotal,
        numberToWords,
        bankAc,
        selectedValue,
        tax_type: form.getFieldValue("tax_type"),
        tax_id: form.getFieldValue("tax_id"),
        type: "QUOTATION",
        quoteTitle
      });

      pdfDoc.output("dataurlnewwindow");
      // pdfDoc.save(`${quotation?.qu_no || "Quotation"}_quotation.pdf`);

    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF!");
    }
  };

  const handleAddPayment = async () => {
    try {
      const request = form.getFieldsValue();
      console.log("handleAddPayment", request.quotationNo);

      setQuotationNo(request.quotationNo);
      setPaymentModalOpen(true);
    } catch (error) {
      console.error("Error in handleAddPayment:", error);
    }
  };

  const handleClear = async () => {
    setDataSource([]);
  };

  return (
    <>
      {msgContc}
      {notiContec}
      <Form form={form} layout="vertical" style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Quotation No"
              name="quotationNo"
              initialValue={data}
              style={{ width: "100%" }}
            >
              <Input disabled placeholder="Enter Quotation No" size="large" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8} style={{ display: "none" }}>
            <Form.Item
              label="Tax type"
              name="tax_type"
              initialValue={data?.tax_type}
            >
              <AutoComplete
                allowClear
                style={{ width: "100%" }}
                disabled
                options={options}
                onSearch={handleSearch}
                placeholder="Enter Tax type (e.g. GST, VAT)"
                size="large"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="GST No" name="tax_id" initialValue={data?.tax_id}>
              <Input
                allowClear
                placeholder="Enter ID (e.g. 09AAACH7409R1ZZ)"
                size="large"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Vaild Till"
              name="vaild_date"
              initialValue={data?.vaild_date}
            >
              <DatePicker
                style={{ width: '100%' }}
                size="large"
                format="DD-MM-YYYY"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Shipping Address"
              name="supply_add"
              initialValue={quteData?.supply_add}
            >
              <Input.TextArea
                rows={3}
                allowClear
                placeholder="Enter Address"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Card style={{ marginTop: "30px", borderBlockColor: "black" }}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              position: "relative",
              marginBottom: '12px',
            }}
          >
            <Input
              placeholder="Enter title for this quotation"
              size="large"
              onChange={(e) => setQuoteTitle(e.target.value)}
            />

            <Divider type="vertical" />

            <Button
              icon={<PlusOutlined />}
              size="large"
              type="primary"
              onClick={handleNewAdd}
            >
              Add Row
            </Button>
            <Divider type="vertical" />
            <Button
              icon={<PlusOutlined />}
              size="large"
              disabled
              color="primary"
              variant="filled"
              onClick={handleQuoteTwo}
            >
              {quoteTwo ? 'Regular View' : 'Quote 2'}
            </Button>
          </div>

          <Table
            dataSource={dataSource}
            columns={columns}
            size="small"
            pagination={false}
            rowKey="id"
            summary={() => {
              if (quoteTwo) {
                // Quote 2 Summary
                const totalQty = dataSource.reduce((sum, item) => {
                  return sum + (Number(item.qty) || 0);
                }, 0);
                
                const supplyTotal = dataSource.reduce((sum, item) => {
                  return sum + (Number(item.supply_amt) || 0);
                }, 0);
                
                const installTotal = dataSource.reduce((sum, item) => {
                  return sum + (Number(item.install_amt) || 0);
                }, 0);

                const numericTaxRate = Number(taxRate) || 0;
                const supplyTax = Math.round((supplyTotal * numericTaxRate) / 100);
                const installTax = Math.round((installTotal * numericTaxRate) / 100);

                const supplyWithTax = supplyTotal + supplyTax;
                const installWithTax = installTotal + installTax;
                
                const calculatedGrandTotal = supplyWithTax + installWithTax;

                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={3}></Table.Summary.Cell>

                      <Table.Summary.Cell index={0} colSpan={2}>
                        <Text strong>Subtotal</Text>
                      </Table.Summary.Cell>
                      
                      <Table.Summary.Cell index={2}>
                        <Text strong>Qty: {totalQty}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3}></Table.Summary.Cell>
                      <Table.Summary.Cell index={4}></Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>
                        <Text strong>{supplyTotal}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}></Table.Summary.Cell>
                      <Table.Summary.Cell index={7}>
                        <Text strong>{installTotal}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8}></Table.Summary.Cell>
                    </Table.Summary.Row>

                    <Table.Summary.Row>
                      <Table.Summary.Cell index={3}></Table.Summary.Cell>
                      <Table.Summary.Cell index={0} colSpan={2}>
                        <Text strong>Tax Rate (%)</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} colSpan={3}>
                        <InputNumber
                          min={0}
                          max={100}
                          value={taxRate || 0}
                          onChange={(value) => setTaxRate(Number(value) || 0)}
                          placeholder="Enter tax %"
                          style={{ width: '100%' }}
                        />
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>
                        <Text>{supplyTax}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}></Table.Summary.Cell>
                      <Table.Summary.Cell index={7}>
                        <Text>{installTax}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8}></Table.Summary.Cell>
                    </Table.Summary.Row>

                    <Table.Summary.Row>
                      <Table.Summary.Cell index={3}></Table.Summary.Cell>
                      <Table.Summary.Cell index={0} colSpan={2}>
                        <Text strong>Total with Tax</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} colSpan={3}></Table.Summary.Cell>
                      <Table.Summary.Cell index={5}>
                        <Text strong>{supplyWithTax}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}></Table.Summary.Cell>
                      <Table.Summary.Cell index={7}>
                        <Text strong>{installWithTax}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8}></Table.Summary.Cell>
                    </Table.Summary.Row>

                    <Table.Summary.Row>
                      <Table.Summary.Cell index={3}></Table.Summary.Cell>
                      <Table.Summary.Cell index={0} colSpan={5}>
                        <Text strong style={{ fontSize: '16px' }}>Grand Total</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5} colSpan={4}>
                        <Text strong style={{ fontSize: '16px' }}>{calculatedGrandTotal}</Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              } else {
                // Regular Summary
                const totalQty = dataSource.reduce((sum, item) => {
                  return sum + (Number(item.qty) || 0);
                }, 0);
                
                const totalprice = dataSource.reduce((sum, item) => {
                  return sum + (Number(item.totalprice) || 0);
                }, 0);

                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={2}>
                      <Text strong>Total</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}>
                      <Text strong>Qty: {totalQty}</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                    <Table.Summary.Cell index={4}></Table.Summary.Cell>
                    <Table.Summary.Cell index={5}></Table.Summary.Cell>
                    <Table.Summary.Cell index={6}>
                      <Text strong>{totalprice}</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={7}></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }
            }}
            scroll={{ x: 'max-content' }}
          />

          <Row style={{ marginTop: 16 }}>
            <Col span={12}>
              <Text italic>In Words: {numberToWords(Number(grandTotal) || 0)} Only</Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text strong>Grand Total: ₹ {(Number(grandTotal) || 0).toLocaleString('en-IN')}</Text>
            </Col>
          </Row>

          <Divider />

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={8}>
              <Form layout="vertical">
                <Form.Item
                  label="Select Terms & Condition"
                  style={{ width: "100%" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <Select
                      placeholder="Select option"
                      options={selectedTCOption}
                      value={selectedValue?.value}
                      size="large"
                      style={{ width: "70%" }}
                      onChange={(value, option) => setSelectedValue(option)}
                    />
                    <Button type="link" onClick={handlePreview}>
                      Preview
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Col>

            <Col span={8}>
              <Form layout="vertical" form={selectBank}>
                <Form.Item
                  label="Select Bank Account"
                  name="bank_ac"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Select option"
                    options={bankAcOption}
                    value={bankAc?.tag}
                    size="large"
                    style={{ width: "70%" }}
                    onChange={(value, option) => setBankAc(option)}
                  />
                </Form.Item>
              </Form>
            </Col>

            <Col span={8}>
              <Form layout="vertical">
                <Form.Item
                  label="Select Digital signature"
                  name="dgselect"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder="Select option"
                    options={dgSignOption}
                    size="large"
                    value={dgSign?.value}
                    style={{ width: "70%" }}
                    optionRender={(option) => option.data.label}
                    fieldNames={{ label: "title", value: "value" }}
                    onChange={(value, option) => setDGsign(option)}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>

          <Divider />

          <Row justify="end" style={{ marginTop: 16 }}>
            <Space>
              {quoteTwo ? (
                <Button
                  size="large"
                  type="primary"
                  onClick={() => handlePrintInvoiceTypeTwo(quteData?.qu_no)}
                >
                  Print Quotation
                </Button>
              ) : (
                <Button
                  size="large"
                  type="primary"
                  onClick={() => handlePrintInvoice(quteData?.qu_no)}
                >
                  Print Quotation
                </Button>
              )}

              <Dropdown.Button
                size="large"
                type="primary"
                onClick={() => handleSave("Active")}
                menu={menu}
              >
                Update
              </Dropdown.Button>

              <Popconfirm title="Sure to clear?" onConfirm={handleClear}>
                <Button disabled={!Eqslected} danger size="large">
                  Clear
                </Button>
              </Popconfirm>
            </Space>
          </Row>
        </div>
      </Card>

      <style>
        {`
      .tandc-preview ul,
      .tandc-preview ol {
        margin: 0 !important;
        padding-left: 20px !important;
        list-style: inherit !important;
      }
      .tandc-preview li {
        margin: 0 !important;
        padding: 0 !important;
        line-height: 1.4 !important;
      }
      .tandc-preview li p,
      .tandc-preview p {
        margin: 0 !important;
        padding: 0 !important;
      }
    `}
      </style>

      <Modal
        title="Preview of selected T&C"
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
      >
        {selectedValue?.data ? (
          <div
            className="tandc-preview"
            style={{
              padding: "10px",
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              background: "#fafafa",
              minHeight: "100px",
            }}
            dangerouslySetInnerHTML={{ __html: selectedValue.data }}
          />
        ) : (
          <p>No data selected</p>
        )}
      </Modal>

      <Modal
        width={800}
        title={
          <Typography.Title level={4}>
            Add Payment for : {quotationNo}
          </Typography.Title>
        }
        open={paymentModalOpen}
        onCancel={() => setPaymentModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        {quotationNo && (
          <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />
        )}
      </Modal>
    </>
  );
};

export default EditQuotationData;